<script setup>
import {onMounted, ref, watch} from "vue";
import dashboardService from "@/services/ecosystem/dashboard.service";

const emit = defineEmits(['completed'])

const step = ref(1);
const hasPortfolio = ref(1);
const show = ref(false);

watch(step, value => {
    if (value === 2 && hasPortfolio.value) {
        step.value = 3;
        return;
    }

    if (value > 2) {
        show.value = false;
        emit('completed');
    }

    saveStep();
});

onMounted(() => {
    getLastStep();
});

async function getLastStep() {
    const {data} = await dashboardService.getOnboardingStep();
    step.value = (data.step && data.step > 0) ? data.step : 1;
    hasPortfolio.value = data.has_portfolio;

    if (step.value <= 2) {
        show.value = true;
    }
}

async function saveStep() {
    await dashboardService.saveOnboardingStep(step.value);
}
</script>

<template>
    <div
        v-if="show"
        id="needs-onboarding"
        class="needs-onboarding"
    >
        <div class="needs-onboarding__inner">
            <div v-if="step === 1">
                <h2 class="heading2">Welcome to SwitchPitch</h2>

                <p class="needs-onboarding__text">View enterprise needs and submit your portfolio startups</p>

                <div class="btn-xl-wrapper">
                    <a @click="step++" class="btn btn-xl btn-xl-next">
                        Get Started
                    </a>
                </div>
            </div>

            <div v-else-if="step === 2">
                <h2 class="heading2">Add Your Startups</h2>

                <form class="form-v2 pb-5">
                    <div class="form-v2__item">
                        <label>Add Via Protfolio URL:</label>
                        <input type="text" />
                    </div>

                    <div class="form-v2__item">
                        <label>Or upload a CSV:</label>

                        <div class="input-file-v2">
                            <label for="ip2">Upload CSV</label>
                            <input type="text" id="ip2" />
                        </div>
                    </div>
                </form>

                <div class="btn-xl-wrapper">
                    <button disabled @click="step++" class="btn btn-xl btn-xl-next">
                        Save & Finish Setup
                    </button>
                </div>

                <div class="mt-3">
                    <a class="link" @click="step++">Skip For Now</a>
                </div>
            </div>
        </div>
    </div>
</template>

<style scoped>
</style>
